import React, { FC, InputHTMLAttributes, useEffect, useState } from 'react';

import searchIcon from 'assets/images/svg/search.svg';

import { useDebounce, useEffectOnUpdate } from '../../../hooks';
import { cn, resultIf } from '../../../utils';
import AnimatedFilterSearch from '../../animations/AnimatedFilterSearch';
import { Image } from '../../common';

import './FilterSearch.scoped.scss';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  search: string;
  onSearchChange: (newSearch: string) => void;
  position: InputPosition;
}

export enum InputPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

const FilterSearch: FC<Props> = ({
  search,
  onSearchChange,
  position = InputPosition.LEFT,
  ...props
}) => {
  const [cachedSearch, setCachedSearch] = useState(search);
  const debouncedSearch = useDebounce(cachedSearch, 600);
  useEffectOnUpdate(() => {
    setCachedSearch(search);
  }, [search]);

  useEffect(() => {
    if (debouncedSearch || search !== cachedSearch) onSearchChange(debouncedSearch);
  }, [debouncedSearch]);

  const handleSearch = (): void => {
    if (search !== cachedSearch) {
      onSearchChange(cachedSearch);
    }
  };
  const [active, setActive] = useState(false);
  const toggle = () => {
    setActive((active) => !active);
  };
  return (
    <>
      <AnimatedFilterSearch active={active}>
        <input
          {...props}
          type="search"
          placeholder={props.placeholder}
          className={cn(
            'filter-search__input',
            resultIf(active, 'active'),
            resultIf(position === InputPosition.RIGHT, 'active--right'),
            props.className
          )}
          value={decodeURIComponent(cachedSearch)}
          onChange={(e) => setCachedSearch(e.target.value)}
          onBlur={handleSearch}
        />
      </AnimatedFilterSearch>
      <Image
        src={searchIcon}
        alt={'search'}
        className={active ? 'filter-search__icon__active' : 'filter-search__icon'}
        onClick={toggle}
      />
    </>
  );
};

export default FilterSearch;
